// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__2PsIh","main":"Layout_main__2M5mV","sidebar":"Layout_sidebar__1xr1l","content":"Layout_content__j6D8g"};